<template>
    <div class="external-activity--header">
        <div v-if="selectedLanguage"><a href="#" class="go-back" @click.prevent="moveBack()" v-if="selectedParent"><i class="fal fa-arrow-left"></i></a></div>
        <img class="activity-logo-dynamic" :class="activity.logo_shape" v-if="activity.logo && !selectedParent" :src="activity.logo">
        <div v-if="selectedLanguage"><a href="#" class="language" @click.prevent="resetLanguage()">{{ selectedLanguage.label.slice(0, 2) }}</a></div>
    </div>
</template>
<script>
    export default {
        props: [
            'activity',
            'selectedLanguage',
            'selectedParent',
            'moveBack',
            'resetLanguage',
        ],
    }
</script>
